import Vue from 'vue'
import VueRouter from 'vue-router'
import activoFijoPg from './routes/activo-fijo-pg'
import sysAdmin from './routes/admin'
import administracion from './routes/administracion'
import administracionPg from './routes/administracion-pg'
import almacenDocumentos from './routes/almacenDocumentos'
import cajaChica from './routes/caja-chica'
import compras from './routes/compras'
import contabilidad from './routes/contabilidad'
import contabilidadPg from './routes/contabilidad-pg'
import controlAsc from './routes/controlAsc'
import controlBines from './routes/controlBines'
import controlCalidad from './routes/controlCalidad'
import controlCostos from './routes/controlCostos'
import controlTicket from './routes/controlTicket'
import convenios from './routes/convenios'
import costos from './routes/costos'
import cxp from './routes/cxp'
import dashboard from './routes/dashboard'
import empresa from './routes/empresa'
import evoucher from './routes/evoucher'
import exportaciones from './routes/exportaciones'
import financiero from './routes/financiero'
import financieroPg from './routes/financiero-pg'
import importacionesPg from './routes/importaciones-pg'
import inventarioConsumo from './routes/inventario-consumo'
import legal from './routes/legal'
import logistica from './routes/logistica'
import logisticaPg from './routes/logistica-pg'
import mantenimientoProgramadoPg from './routes/mantenimiento-pg'
import marketing from './routes/marketing'
import monitoreoPesca from './routes/monitoreoPesca'
import pages from './routes/pages'
import palletizado from './routes/palletizado'
import perfil from './routes/perfil'
import personaPG from './routes/persona-pg'
import personas from './routes/personas'
import presupuesto from './routes/presupuesto'
import produccion from './routes/produccion'
import produccionPg from './routes/producion-pg'
import profremar from './routes/profremar'
import rrhh from './routes/recursosHumanos'
import sistemaDocumentos from './routes/sistemaDocumentos'
import sistemas from './routes/sistemas'
import solicitudes from './routes/solicitudes'
import tableroControl from './routes/tableroControl'
import temperatura from './routes/temperatura'
import tributacion from './routes/tributacion'
import tributacionPg from './routes/tributacion-pg'
import ventas from './routes/ventas'
import ventasNacionales from './routes/ventasNacionales'
import { getHomeRouteForLoggedInUser, isEmpresaSet, isResetPassword, isUserLoggedIn } from '@/auth/utils'
// Routes
import { canNavigate } from '@/libs/acl/routeProtection'

Vue.use(VueRouter)
const router = new VueRouter({
    mode: 'history',
    base: import.meta.env.VITE_PREFIX,
    scrollBehavior() {
        return { x: 0, y: 0 }
    },
    routes: [
        { path: '/', redirect: { name: 'dashboard-general' } },
        ...dashboard,
        ...pages,
        ...exportaciones,
        ...personas,
        ...produccion,
        ...tributacion,
        ...controlBines,
        ...financiero,
        ...almacenDocumentos,
        ...empresa,
        ...contabilidad,
        ...monitoreoPesca,
        ...ventasNacionales,
        ...ventas,
        ...sistemas,
        ...perfil,
        ...controlCalidad,
        ...palletizado,
        ...legal,
        ...logistica,
        ...rrhh,
        ...sistemaDocumentos,
        ...controlCostos,
        ...controlAsc,
        ...temperatura,
        ...costos,
        ...administracion,
        ...profremar,
        ...compras,
        ...tableroControl,
        ...controlTicket,
        ...cxp,
        ...tributacionPg,
        ...contabilidadPg,
        ...marketing,
        ...financieroPg,
        ...presupuesto,
        ...personaPG,
        ...evoucher,
        ...inventarioConsumo,
        ...sysAdmin,
        ...importacionesPg,
        ...activoFijoPg,
        ...mantenimientoProgramadoPg,
        ...logisticaPg,
        ...produccionPg,
        ...solicitudes,
        ...administracionPg,
        ...convenios,
        ...cajaChica,
        {
            path: '*',
            redirect: 'error-404',
        },
    ],
})

router.beforeEach((to, _, next) => {
    const isLoggedIn = isUserLoggedIn()
    const isEmpresa = isEmpresaSet()
    const isReset = isResetPassword()

    if (!canNavigate(to)) {
        // Redirect to login if not logged in
        if (!isLoggedIn) {
            return next({ name: 'auth-login' })
        }
        // Redirect to empresa if not empresa set
        if (!isEmpresa && isLoggedIn) {
            return next({ name: 'empresa' })
        }

        // If logged in => not authorized
        return next({ name: 'not-authorized' })
    }
    // Redirect if logged in
    if (to.meta?.redirectIfLoggedIn && isLoggedIn) {
        // Redirect if empresa set
        if (isEmpresa) {
            // const userData = getUserData()
            return next(getHomeRouteForLoggedInUser())
        }
        return next({ name: 'empresa' })
    }
    if (to.meta?.redirectIfNoEmpresa && !isEmpresa) {
        return next({ name: 'empresa' })
    }
    if (to.meta?.redirectIfReset && isReset) {
        return next({ name: 'perfil', query: { tab: 1 } })
    }

    return next()
})

// Promise.all([
//     import('@core/auth/jwt/useJwt'),
//     import('@axios'),
// ]).then(([composable, axios]) => {
//     const { jwt: jwtService } = composable.default(axios.default)
//     const logoutListener = (status: string) => {
//         router.push({ name: 'auth-login', params: { alert: status }})
//     }
//     jwtService.addOnExpireListener(logoutListener)
// })

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
    // Remove initial loading
    const appLoading = document.querySelector('#loading-bg')
    if (appLoading) {
        appLoading.style.display = 'none'
    }
})

export default router
